import Wrapper from "../../Wrapper";

 const Users = ()=>{
     return (
         <>
         <Wrapper>
            <h3 style={{textAlign: "center",position: "relative", top: "50px", color:"#bf2527"}}>Users</h3>
         </Wrapper>
         </>
     );
 }
 export default Users;